import { Typography } from '@mui/material';
import { RefObject } from 'react';

type NavigationTabProps = {
  label: string;
  isSelected: boolean;
  ref: RefObject<HTMLElement | null>;
};

export const NavigationTab: React.FC<NavigationTabProps> = ({ label, isSelected, ref }: NavigationTabProps) => {
  const executeScroll = (ref: RefObject<HTMLElement | null>) => ref.current?.scrollIntoView({ behavior: 'smooth' });

  return (
    <Typography
      variant="labelLight"
      onClick={() => executeScroll(ref)}
      sx={{
        py: 0.4,
        width: 136,
        textAlign: 'center',
        cursor: 'pointer',
        '&:hover': {
          color: 'text.brandHover',
        },
        ...(isSelected ? { color: 'text.brand', borderBottom: '2px solid', borderColor: 'text.brand' } : {}),
      }}
    >
      {label}
    </Typography>
  );
};
